export {
  COMPARE_PRODUCT_LOCAL_STORAGE_KEY,
  MAX_PRODUCTS_TO_COMPARE,
  productHasBeenInitialzed,
  productForComparisonState,
  productSlugState,
  productsForComparisonState,
} from "./product-props";
